export const env = import.meta.env.MODE
export const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID
export const baseURL = import.meta.env.VITE_BASE_URL
export const hostName = window.location.hostname
const isEmulating = hostName === 'localhost'
export const isDevelopment = env === 'development' || isEmulating
export const databaseVersion = import.meta.env.VITE_DATABASE_VERSION
export const sentryDSN = import.meta.env.VITE_SENTRY_DSN
export const isStaging = !isDevelopment && projectId === 'huntre-dev'
export const serviceName = isStaging ? 'ワナップ(stg)' : 'ワナップ'

// 価格関連はここに集約する。改定時はここだけ直せば全画面に反映される。
export const devicePriceNumber = '55,000' // デバイス本体の定価 (税込・円)。¥表記や「円」付与は参照側で行う
export const deviceCampaignPriceNumber = '50,000' // 初回導入キャンペーン価格 (税込・円)
export const deviceCampaignLabel = '初回導入キャンペーン' // キャンペーンの表示ラベル
export const devicePriceNote = '※価格は改定される場合があります' // 値上げ余地を残すための注記
export const stripeConfig = {
  productId: {
    device: import.meta.env.VITE_STRIPE_DEVICE_PRODUCT_ID,
    simPlan: import.meta.env.VITE_STRIPE_SIM_PRODUCT_ID,
  },
}
export const corporateSiteUrl = import.meta.env.VITE_CORPORATE_SITE_URL ?? ''
export const registerFormUrl = import.meta.env.VITE_REGISTER_FORM_URL ?? ''
export const inquiryFormUrl = import.meta.env.VITE_INQUIRY_FORM_URL ?? ''
export const appCheckSecret = import.meta.env.VITE_FIREBASE_APP_CHECK_SECRET
export const supportEmail = import.meta.env.VITE_SUPPORT_EMAIL ?? ''
export const noreplyEmail = import.meta.env.VITE_NOREPLY_EMAIL ?? ''
export const supportPhone = import.meta.env.VITE_SUPPORT_PHONE ?? ''
export const lineId = import.meta.env.VITE_LINE_ID ?? ''

// 買取 (docs/specs/device-buyback.md)
// 買取対象の deviceType id。カンマ区切り
export const buybackDeviceTypeIds = (import.meta.env.VITE_BUYBACK_DEVICE_TYPE_IDS ?? '')
  .split(',')
  .map((v: string) => v.trim())
  .filter((v: string) => v !== '')
// 送付先。approved になってから画面に出す
export const buybackShipping = {
  name: import.meta.env.VITE_BUYBACK_SHIPPING_NAME ?? '',
  postalCode: import.meta.env.VITE_BUYBACK_SHIPPING_POSTAL_CODE ?? '',
  address: import.meta.env.VITE_BUYBACK_SHIPPING_ADDRESS ?? '',
}

// 古物商許可 (古物営業法 12 条 2 項)
// **ホームページ利用取引をするときは「トップページ」に氏名又は名称・許可をした公安委員会の
// 名称・許可証の番号を表示する義務がある**。買取の申込画面だけでは要件を満たさないので、
// 全ページに出る Footer と特商法ページ、買取申込画面の 3 箇所から参照している。
// env にしていないのは、stg / prod で変わらない会社情報だから (送付先と違いダミーも要らない)。
export const kobutsuLicense = {
  holder: '株式会社Xenon',
  authority: '群馬県公安委員会',
  number: '421112026096',
}
export const kobutsuLicenseText = `${kobutsuLicense.holder} ${kobutsuLicense.authority} 第${kobutsuLicense.number}号`

// docomo
// export const availableAreaUrl = https://www.docomo.ne.jp/area/servicearea/?rgcd=03&cmcd=LTE
// au
export const availableAreaUrl = 'https://www.au.com/mobile/area/map/?ope=au&plan=4glte'
